/* Velas del Caribe: the cart's "¿Dónde Te Lo Llevamos?" form (snippets/vdc-direccion.liquid).
   The sector is picked from the INPOSDOM list, which gives the postal code and the delivery price; the
   picked address is saved as cart attributes and as the cart's delivery address (Storefront API), and
   "Ir A Pagar" opens /checkout with Shopify's checkout[shipping_address][...] parameters, so the
   checkout starts filled in and prices delivery by postal code. Nothing here blocks checkout: with no street and no sector the button works as Dawn's.
   Dawn re-renders the drawer after every cart change; a MutationObserver prepares each new copy. */
(function () {
  if (window.vdcDireccion) return; // the snippet is on the drawer and on /cart, each with this tag
  window.vdcDireccion = true;
  var lista = null, cargando = null, estado = { calle: '', elegido: null }, guardado = '';

  var sinAcentos = function (s) { return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var PALABRAS_VACIAS = { de: 1, del: 1, la: 1, las: 1, los: 1, el: 1, y: 1 };
  var nombre = function (e) { return e[1] ? e[0] + ', ' + e[1] : e[0]; };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function cargar(caja) {
    if (!cargando) {
      cargando = fetch(caja.dataset.codigos).then(function (r) { return r.json(); }).then(function (d) {
        lista = d.map(function (e) { return { e: e, texto: sinAcentos(nombre(e)), sector: sinAcentos(e[0]) }; });
        return lista;
      }).catch(function () { cargando = null; return []; });
    }
    return cargando;
  }

  /* Every typed word must appear; "los", "de"... are ignored when other words remain. Sectors that start
     with the whole text come first ("Los Mina" before "La Mina"), then those that start with its main
     words, then those with a word starting with the first one, then the rest. */
  function buscar(q) {
    var p = sinAcentos(q).split(/[\s,.]+/).filter(Boolean);
    var llenas = p.filter(function (w) { return !PALABRAS_VACIAS[w]; });
    if (llenas.length) p = llenas;
    if (!p.length || !lista) return [];
    var frase = p.join(' '), entera = sinAcentos(q).trim().replace(/\s+/g, ' ');
    return lista.filter(function (x) { return p.every(function (w) { return x.texto.indexOf(w) >= 0; }); })
      .map(function (x) {
        var r = x.sector.indexOf(entera) === 0 ? 0 : x.sector.indexOf(frase) === 0 ? 1 : (' ' + x.texto).indexOf(' ' + p[0]) >= 0 ? 2 : 3;
        return { x: x, r: r };
      })
      .sort(function (a, b) { return a.r - b.r || a.x.texto.localeCompare(b.x.texto); })
      .slice(0, 8).map(function (o) { return o.x.e; });
  }

  /* The delivery zone of a postal code: 'gratis', 'local' or 'pais' (the box's data-gratis / data-local prefixes). */
  function zona(caja, zip) {
    var en = function (k) { return caja.dataset[k].split(',').some(function (p) { p = p.trim(); return p && zip.indexOf(p) === 0; }); };
    return en('gratis') ? 'gratis' : en('local') ? 'local' : 'pais';
  }

  function precio(caja, zip) {
    var z = zona(caja, zip);
    return z === 'gratis' ? caja.dataset.precioGratis : z === 'local' ? caja.dataset.precioLocal : caja.dataset.precioPais;
  }

  function pintar(caja) {
    var e = estado.elegido, res = caja.querySelector('.vdc-direccion-resultado');
    res.hidden = !e;
    if (e) {
      caja.querySelector('.vdc-zip').textContent = e[2];
      caja.querySelector('.vdc-precio').textContent = precio(caja, e[2]);
    }
  }

  function avisar(caja, texto) { caja.querySelector('.vdc-direccion-aviso').textContent = texto || ''; }

  /* Cart attributes, so the order shows the picked address too (and a re-rendered drawer keeps it). extra: more
     attributes written in the same call (the payment page's gift and address parts; it may override 'Dirección'). */
  function guardar(extra) {
    var e = estado.elegido;
    var attrs = Object.assign({ 'Dirección': estado.calle, Sector: e ? nombre(e) : '', 'Código postal': e ? e[2] : '' }, extra);
    var clave = JSON.stringify(attrs);
    if (clave === guardado) return Promise.resolve();
    guardado = clave;
    return fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function () {});
  }

  /* Copy the shared state into every form on the page (the drawer and /cart may both be there). */
  function sincronizar(origen) {
    document.querySelectorAll('.vdc-direccion').forEach(function (caja) {
      if (caja !== origen) {
        caja.querySelector('.vdc-calle').value = estado.calle;
        caja.querySelector('.vdc-sector').value = estado.elegido ? nombre(estado.elegido) : '';
        avisar(caja, '');
      }
      pintar(caja);
    });
    document.dispatchEvent(new CustomEvent('vdc-direccion')); // the payment page (vdc-pago.js) listens
  }

  function cerrarLista(caja) {
    var ul = caja.querySelector('.vdc-sector-lista'), inp = caja.querySelector('.vdc-sector');
    ul.hidden = true; ul.innerHTML = '';
    inp.setAttribute('aria-expanded', 'false'); inp.removeAttribute('aria-activedescendant');
  }

  function abrirLista(caja, res) {
    var ul = caja.querySelector('.vdc-sector-lista'), inp = caja.querySelector('.vdc-sector');
    ul.innerHTML = res.map(function (e, i) {
      return '<li id="' + ul.id + '-' + i + '" role="option" aria-selected="false" data-i="' + i + '">' + esc(nombre(e)) + '</li>';
    }).join('');
    ul._res = res;
    ul.hidden = !res.length;
    inp.setAttribute('aria-expanded', res.length ? 'true' : 'false');
  }

  function elegir(caja, e) {
    estado.elegido = e;
    caja.querySelector('.vdc-sector').value = nombre(e);
    cerrarLista(caja);
    avisar(caja, '');
    sincronizar(caja);
    guardar();
  }

  function preparar(caja) {
    caja.dataset.listo = '1';
    var calle = caja.querySelector('.vdc-calle'), inp = caja.querySelector('.vdc-sector');
    if (estado.calle || estado.elegido) {
      calle.value = estado.calle;
      inp.value = estado.elegido ? nombre(estado.elegido) : '';
      pintar(caja);
      return;
    }
    // First paint: the values Liquid wrote from the cart attributes.
    estado.calle = calle.value;
    if (inp.value && inp.dataset.zip) {
      cargar(caja).then(function () {
        var e = (lista || []).map(function (x) { return x.e; }).filter(function (e) { return e[2] === inp.dataset.zip && nombre(e) === inp.value; })[0];
        if (e && !estado.elegido) { estado.elegido = e; sincronizar(); }
      });
    }
    guardado = JSON.stringify({ 'Dirección': calle.value, Sector: inp.value, 'Código postal': inp.dataset.zip || '' });
  }

  function cajaDe(el) { return el && el.closest ? el.closest('.vdc-direccion') : null; }

  document.addEventListener('input', function (ev) {
    var caja = cajaDe(ev.target);
    if (!caja) return;
    if (ev.target.classList.contains('vdc-calle')) { estado.calle = ev.target.value; return; }
    if (!ev.target.classList.contains('vdc-sector')) return;
    if (estado.elegido) { estado.elegido = null; pintar(caja); document.dispatchEvent(new CustomEvent('vdc-direccion')); }
    var q = ev.target.value;
    cargar(caja).then(function () {
      if (ev.target.value !== q) return;
      var res = q.trim().length >= 2 ? buscar(q) : [];
      abrirLista(caja, res);
      avisar(caja, q.trim().length >= 3 && !res.length ? caja.dataset.noEncontrado : '');
    });
  });

  document.addEventListener('focusin', function (ev) { var caja = cajaDe(ev.target); if (caja && ev.target.classList.contains('vdc-sector')) cargar(caja); });

  document.addEventListener('change', function (ev) {
    var caja = cajaDe(ev.target);
    if (caja && ev.target.classList.contains('vdc-calle')) { estado.calle = ev.target.value.trim(); sincronizar(caja); guardar(); }
  });

  document.addEventListener('focusout', function (ev) {
    var caja = cajaDe(ev.target);
    if (!caja || !ev.target.classList.contains('vdc-sector')) return;
    setTimeout(function () {
      if (caja.contains(document.activeElement)) return;
      cerrarLista(caja);
      if (!estado.elegido && ev.target.value.trim()) avisar(caja, caja.dataset.elige);
      if (!estado.elegido) guardar();
    }, 150);
  });

  // pointerdown, not click: the option must win before the input's blur closes the list.
  document.addEventListener('pointerdown', function (ev) {
    var li = ev.target.closest && ev.target.closest('.vdc-sector-lista [role="option"]');
    if (!li) return;
    ev.preventDefault();
    elegir(cajaDe(li), li.parentNode._res[+li.dataset.i]);
  });

  document.addEventListener('keydown', function (ev) {
    var caja = cajaDe(ev.target);
    if (!caja || !ev.target.classList.contains('vdc-sector')) return;
    var ul = caja.querySelector('.vdc-sector-lista'), ops = ul.querySelectorAll('[role="option"]');
    if (ul.hidden || !ops.length) return;
    var actual = [].indexOf.call(ops, ul.querySelector('[aria-selected="true"]'));
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      ev.preventDefault();
      var n = ev.key === 'ArrowDown' ? (actual + 1) % ops.length : actual <= 0 ? ops.length - 1 : actual - 1;
      ops.forEach(function (o, i) { o.setAttribute('aria-selected', i === n ? 'true' : 'false'); });
      ev.target.setAttribute('aria-activedescendant', ops[n].id);
      ops[n].scrollIntoView({ block: 'nearest' });
    } else if (ev.key === 'Enter') {
      ev.preventDefault();
      elegir(caja, ul._res[actual < 0 ? 0 : actual]);
    } else if (ev.key === 'Escape') {
      cerrarLista(caja);
    }
  });

  /* The cart's own delivery address (Storefront API, tokenless, same origin). A checkout that already
     exists keeps pricing the address it was first given, whatever the URL says; and an address edited in
     place does not bring local delivery back once a far one ruled it out. Removing the cart's addresses
     and adding the new one does (proved on this store, 2026-10-12: 10148 -> 41002 -> 11901 in one cart). */
  var API = '/api/2026-10/graphql.json';
  function gql(query, variables) {
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: query, variables: variables }) })
      .then(function (r) { return r.json(); });
  }
  /* The Storefront id of the theme's cart (same cart: the token of /cart.js). */
  function carritoId() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { return 'gid://shopify/Cart/' + c.token; });
  }
  /* tipo: the delivery method to select after the address is set ('LOCAL' when not given). */
  function direccionDelCarrito(direccion, tipo) {
    return carritoId().then(function (id) {
      return gql('query($id: ID!) { cart(id: $id) { delivery { addresses { id } } } }', { id: id }).then(function (j) {
        var ids = (j.data && j.data.cart && j.data.cart.delivery.addresses || []).map(function (a) { return a.id; });
        return ids.length ? gql('mutation($id: ID!, $a: [ID!]!) { cartDeliveryAddressesRemove(cartId: $id, addressIds: $a) { userErrors { message } } }', { id: id, a: ids }) : null;
      }).then(function () {
        if (!direccion) return null;
        return gql('mutation($id: ID!, $a: [CartSelectableAddressInput!]!) { cartDeliveryAddressesAdd(cartId: $id, addresses: $a) { userErrors { message } } }',
          { id: id, a: [{ selected: true, address: { deliveryAddress: direccion } }] }).then(function () { return entregaLocal(id, tipo); });
      });
    });
  }

  /* Checkout pre-selects the cheapest option, and on a tie DOMEX pickup comes first; where the address
     gets local delivery (the zones the cart priced), that one is selected so the order goes home. Checkout
     honors the cart's selection (proved on this store, 2026-10-13, Piantini 10148). The payment page passes
     tipo 'SHIPPING' when the shopper picks DOMEX pickup. */
  function entregaLocal(id, tipo) {
    return gql('query($id: ID!) { cart(id: $id) { deliveryGroups(first: 5) { nodes { id deliveryOptions { handle deliveryMethodType } } } } }', { id: id }).then(function (j) {
      var sel = (j.data && j.data.cart ? j.data.cart.deliveryGroups.nodes : []).map(function (g) {
        var o = g.deliveryOptions.filter(function (d) { return d.deliveryMethodType === (tipo || 'LOCAL'); })[0];
        return o && { deliveryGroupId: g.id, deliveryOptionHandle: o.handle };
      }).filter(Boolean);
      return sel.length ? gql('mutation($id: ID!, $s: [CartSelectedDeliveryOptionInput!]!) { cartSelectedDeliveryOptionsUpdate(cartId: $id, selectedDeliveryOptions: $s) { userErrors { message } } }', { id: id, s: sel }) : null;
    });
  }

  /* Remembers on this browser that the script gave the cart a delivery address, so an empty form can take
     it away again, while a cart that never had one keeps Dawn's checkout with no Storefront call. */
  var MARCA = 'vdcDireccionCarrito';
  var marca = function (v) { try { if (v === undefined) return localStorage.getItem(MARCA); if (v) localStorage.setItem(MARCA, '1'); else localStorage.removeItem(MARCA); } catch (x) { return null; } };

  /* Runs salir once: when the chain ends (well or not) or after 3 s (ms, when given), so a hung request never
     leaves "Ir A Pagar" doing nothing. */
  function luego(cadena, salir, ms) {
    var hecho = false, una = function () { if (!hecho) { hecho = true; salir(); } };
    setTimeout(una, ms || 3000);
    cadena.then(una, una);
  }

  /* "Ir A Pagar": with a street or a picked sector, save the attributes, give the cart that address and
     open the checkout filled in (Shopify reads checkout[shipping_address][...] on /checkout). With both
     fields empty, Dawn's own checkout runs; if the script had given this cart an address, it is removed
     first and the checkout opens with the address fields blanked, because a checkout also remembers the
     address it was last given. If the Storefront API fails or hangs, the checkout still opens (filled in
     when the form has data), as before. */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('button[name="checkout"]');
    if (!b || b.disabled) return;
    var e = estado.elegido, calle = estado.calle.trim();
    if (!e && !calle) {
      if (!marca()) return; // nothing typed and no address of ours on the cart: Dawn's own checkout, as before
      ev.preventDefault();
      b.setAttribute('aria-busy', 'true');
      var vacia = new URLSearchParams();
      ['address1', 'city', 'zip'].forEach(function (k) { vacia.set('checkout[shipping_address][' + k + ']', ''); });
      vacia.set('checkout[shipping_address][country]', 'DO');
      luego(guardar().then(function () { return direccionDelCarrito(null); }).then(function () { marca(false); }), function () {
        location.href = '/checkout?' + vacia.toString();
      });
      return;
    }
    ev.preventDefault();
    var linea = [calle, e && e[1] ? e[0] : ''].filter(Boolean).join(', ');
    var direccion = e ? { address1: linea, city: e[1] || e[0], zip: e[2], countryCode: 'DO' } : null;
    var q = new URLSearchParams();
    if (linea) q.set('checkout[shipping_address][address1]', linea);
    if (e) {
      q.set('checkout[shipping_address][city]', direccion.city);
      q.set('checkout[shipping_address][zip]', e[2]);
    }
    q.set('checkout[shipping_address][country]', 'DO');
    b.setAttribute('aria-busy', 'true');
    if (direccion) marca(true);
    luego(guardar().then(function () { return direccionDelCarrito(direccion); }), function () { location.href = '/checkout?' + q.toString(); });
  }, true);

  /* For the payment page (assets/vdc-pago.js): the same state, zone logic, attributes and Storefront calls. */
  window.vdcDireccionApi = {
    estado: estado, nombre: nombre, zona: zona, guardar: guardar, gql: gql, carritoId: carritoId,
    direccionDelCarrito: direccionDelCarrito, marca: marca, luego: luego
  };

  function prepararTodas() { document.querySelectorAll('.vdc-direccion:not([data-listo])').forEach(preparar); }
  prepararTodas();
  new MutationObserver(prepararTodas).observe(document.body, { childList: true, subtree: true });
})();
